import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ControlledMenu, useClick, useMenuState } from "@szhsin/react-menu";
import React from "react";
import { useRef, useState } from "react";
import { MenuDropdownContext, usePortalContainer } from "./MenuContext";
import cls from "./button-dropdown.module.scss";
import classNames from "classnames";
import { SubMenu } from "./SubMenu";
import { MenuItem } from "./MenuItem";
export const MenuBarItem = (props) => {
    return null;
};
export const CustomMenu = (props) => {
    const { menu, selectedIndex, setSelectedIndex, index, openStateClassName, button, hoverDelay = 100 } = props;
    const { menuClassName, menuButtonClassName } = React.useContext(MenuDropdownContext);
    const ref = useRef(null);
    const [menuState, toggleMenu] = useMenuState({ transition: true, initialMounted: false, unmountOnClose: true });
    const setOpen = React.useCallback((value) => {
        value ? setSelectedIndex(index) : setSelectedIndex(-1);
        toggleMenu(value);
    }, [index, setSelectedIndex, toggleMenu]);
    const anchorProps = useClick(menuState.state, setOpen);
    const timerRef = React.useRef();
    React.useEffect(() => {
        toggleMenu(selectedIndex === index);
    }, [index, selectedIndex, toggleMenu]);
    const onMouseEnter = (e) => {
        if (selectedIndex === -1)
            return;
        if (!hoverDelay) {
            setSelectedIndex(index);
            return;
        }
        timerRef.current = setTimeout(() => {
            clearTimeout(timerRef.current);
            setSelectedIndex(index);
        }, hoverDelay);
    };
    const onMouseLeave = (e) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
    };
    const clonedButton = React.cloneElement(button, {
        ref, onMouseEnter, onMouseLeave, ...anchorProps,
        className: classNames(button.props.className, menuButtonClassName, { [openStateClassName]: selectedIndex === index })
    });
    const newMenuClassName = (x) => {
        const old = typeof menu.menuClassName === "function" ? menu.menuClassName(x) : menu.menuClassName;
        const mew = typeof menuClassName === "function" ? menuClassName(x) : menuClassName;
        return classNames(old, mew);
    };
    const container = usePortalContainer(menuState.state);
    return _jsxs(_Fragment, { children: [clonedButton, _jsx(ControlledMenu, { ...menu, ...menuState, menuClassName: newMenuClassName, portal: { target: container }, unmountOnClose: true, initialMounted: false, anchorRef: ref, className: "bg-white", onClose: (e) => {
                    setOpen(false);
                } })] });
};
export const MenuBar = (props) => {
    const [index, setIndex] = useState(-1);
    React.Children.forEach(props.children, (child) => {
        if (child.type !== MenuBarItem) {
            throw new Error("Children of Menubar can only be MenuBarItem");
        }
    });
    const { openStateClassName = "focus", menuClassName = cls.menu, menuItemClassName = cls.menuItem, menuItemHoverClassName = cls.menuItemHover, menuItemDisabledClassName = cls.menuItemDisabled, menuItemWithSubMenuClassName = cls.menuItemWithSubMenu, menuButtonClassName, hoverDelay } = props;
    const menus = React.Children.toArray(props.children);
    return _jsx(MenuDropdownContext.Provider, { value: { menuButtonClassName, menuClassName, menuItemClassName, menuItemHoverClassName, menuItemDisabledClassName, menuItemWithSubMenuClassName }, children: _jsx("div", { className: props.className, style: props.style, children: menus.map(({ props: { menuButton, ...props } }, key) => _jsx(CustomMenu, { button: menuButton, menu: props, selectedIndex: index, setSelectedIndex: setIndex, index: key, openStateClassName: openStateClassName, hoverDelay: hoverDelay }, key)) }) });
};
MenuBar.SubMenu = SubMenu;
MenuBar.MenuItem = MenuItem;
